export default "assets/images/icons/instagram-8a30a8e0.svg";